// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5">
            <path
                fill="currentColor"
                d="M3.47 4.28a.751.751 0 0 0 1.062 0l3-3A.75.75 0 0 0 7-.002L1 0a.753.753 0 0 0-.532 1.282l3 3 .003-.002Z"
            />
        </svg>
    );
};

export default React.memo(CaretDown);
